<template>
  <v-container class="chat-fondo" style="margin-top: -20px; height: 650px;" id="containerChat">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card
          class="elevation-12"
          id="chatBoot"
          style="
            left: 25%;
            margin: 10px 0 10px 0;
            border-radius: 10px;
            background: #ffffffbd;
            z-index: 202;
          "
          width="700px"
          max-height="690px"
          min-height="500px"
        >
          <v-toolbar
            dark
            color="#294697"
            height="60px"
            class="chat-header"
            dense
            style="border-radius: 10px 10px 0 0"
          >
            <v-icon>mdi-robot</v-icon>
            <span style="font-size: 17px; font-weight: bold; margin-left: 10px">
              NOVA</span
            >
          </v-toolbar>
          <div
            id="divu"
            class="card-body"
            style="margin-top: 15px; width: 100%; max-height: 420px"
          >
            <div class="loader" v-if="ipValidated == 1">
              <span></span>
            </div>
            <!-- ipValidated => 1 - Cargando -->
            <!-- ipValidated => 2 - Si tiene -->
            <!-- ipValidated => 3 - No tiene -->
            <div class="ip-validator" v-if="ipValidated == 3">
              <h1>¿En qué punto te encuentras?</h1>
              <v-autocomplete
                :items="puntos"
                v-model="puntoSelect"
                item-text="nombre"
                item-value="idPunto"
                label="Selecciona el punto"
                color="#294697"
                :disabled="loading"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.nombreEmpresa">
                      <strong>Empresa:</strong> {{ item.nombreEmpresa }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <span>{{ item.nombre }} <strong v-if="item.nombreEmpresa">({{ item.nombreEmpresa }})</strong></span>
                </template>
              </v-autocomplete>
              <v-btn
                color="#1D3C7F"
                class="btn-texto-blanco"
                elevation="2"
                @click="sendInfo"
                :disabled="!puntoSelect || loading"
                :loading="loading"
                >{{ loading ? "Enviando..." : "Enviar" }}</v-btn
              >
            </div>
            <div style="height: 300px; overflow-y: scroll" v-chat-scroll>
              <div v-for="(msg, index) in messages" :key="index">
                <div v-if="msg.user === user">
                  <p
                    class="msg-msg"
                    id="messageUser"
                    style="
                      border-radius: 10px;
                      width: 50%;
                      padding: 5px 10px 5px 10px;
                      margin: 5px 10px 0;
                      background: #1D3C7F;
                      color: #fff;
                      font-size: 15px;
                      margin-left: 340px;
                    "
                  >
                    <span style="font-size: 17px; font-weight: bold">{{
                      msg.user
                    }}</span>
                    <br />
                    {{ msg.message }}
                    <div v-if="msg.imageUrl" class="image-preview">
                      <!-- Si imageUrl es un string JSON (múltiples imágenes o archivos) -->
                      <template v-if="isJsonString(msg.imageUrl)">
                        <div v-for="(url, imgIndex) in JSON.parse(msg.imageUrl)" :key="imgIndex" class="chat-image-container">
                          <template v-if="url && url.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)">
                            <img :src="url" alt="Evidencia" class="uploaded-image" @click="openImageFullscreen(url)" />
                          </template>
                          <template v-else>
                            <v-icon color="primary" class="file-icon-compact" left>mdi-file</v-icon>
                            <a :href="url" target="_blank" class="file-name-compact" style="text-decoration:none; color:#333;">{{ getFileName(url) }}</a>
                          </template>
                        </div>
                      </template>
                      <!-- Si imageUrl es una URL simple (una sola imagen o archivo) -->
                      <template v-else>
                        <template v-if="msg.imageUrl && msg.imageUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)">
                          <img :src="msg.imageUrl" alt="Evidencia" class="uploaded-image" @click="openImageFullscreen(msg.imageUrl)" />
                        </template>
                        <template v-else>
                          <v-icon color="primary" class="file-icon-compact" left>mdi-file</v-icon>
                          <a :href="msg.imageUrl" target="_blank" class="file-name-compact" style="text-decoration:none; color:#333;">{{ getFileName(msg.imageUrl) }}</a>
                        </template>
                      </template>
                    </div>
                    <!-- Soporte para el nuevo formato imageUrls -->
                    <div v-else-if="msg.imageUrls && Array.isArray(msg.imageUrls) && msg.imageUrls.length > 0" class="image-preview">
                      <div v-for="(url, imgIndex) in msg.imageUrls" :key="imgIndex" class="chat-image-container">
                        <template v-if="url && url.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)">
                          <img :src="url" alt="Evidencia" class="uploaded-image" @click="openImageFullscreen(url)" />
                        </template>
                        <template v-else>
                          <v-icon color="primary" class="file-icon-compact" left>mdi-file</v-icon>
                          <a :href="url" target="_blank" class="file-name-compact" style="text-decoration:none; color:#333;">{{ getFileName(url) }}</a>
                        </template>
                      </div>
                    </div>
                  </p>
                </div>
                <div v-else>
                  <p
                    class="msg-msg"
                    id="messageBot"
                    style="
                      border-radius: 10px;
                      width: 50%;
                      padding: 5px 10px 5px 10px;
                      margin: 5px 10px 0;
                      background: #294697;
                      color: #fff;
                      font-size: 15px;
                    "
                  >
                    <span style="font-size: 17px; font-weight: bold">{{
                      msg.user
                    }}</span>
                    <br />
                    {{ msg.message }}
                    <span v-if="cant == index">
                      <span
                        v-if="bottones == 1"
                        style="display: flex; flex-direction: column"
                      >
                        <v-btn @click="boton" :disabled="buttonPressed || botonOkDisabled" class="mb-5 mt-5 btn1">
                          {{ botonOkDisabled ? 'Espere...' : 'OK' }}
                        </v-btn>
                      </span>
                      <span
                        v-else-if="bottones == 2"
                        style="display: flex; flex-direction: column"
                      >
                        <v-btn
                          :disabled="!openBot || loadingMessageBot || buttonPressed"
                          @click="boton2"
                          class="mb-5 mt-5 btn1"
                        >
                          si
                        </v-btn>
                        <v-btn
                          :disabled="!openBot || loadingMessageBot || buttonPressed"
                          @click="boton1"
                          class="mb-5 btn1"
                        >
                          no
                        </v-btn>
                      </span>
                      <span
                        v-else-if="bottones == 4"
                        style="display: flex; flex-direction: column"
                      >
                      </span>
                      <span v-else style="display: flex; flex-direction: column">
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <!-- 🆕 Indicador de carga entre preguntas -->
              <div v-if="mostrarCargandoPregunta" class="loading-message">
                <p class="msg-msg" style="
                  border-radius: 10px;
                  width: 50%;
                  padding: 5px 10px 5px 10px;
                  margin: 5px 10px 0;
                  background: #294697;
                  color: #fff;
                  font-size: 15px;
                ">
                  <span style="font-size: 17px; font-weight: bold">NOVA</span>
                  <br />
                  Espere<span class="dots-animation">...</span>
                </p>
              </div>
            </div>
          </div>
          <v-layout v-if="bottones == 3" wrap style="margin-top: 30px">
            <v-flex xs12 sm9 md9>
              <v-text-field
                color="#294697"
                type="text"
                style="margin-left: 10px"
                v-model="message"
              ref="messageInput"
                outlined=""
                v-on:keyup.enter="sendMessage"
                single-line
                :disabled="!openBot || loadingMessageBot || waitingForNextQuestion"
              :autofocus="bottones === 3 && !loadingMessageBot && !waitingForNextQuestion"
                :placeholder="
                  loadingMessageBot ? 'Cargando...' : 
                  waitingForNextQuestion ? 'Esperando siguiente pregunta...' :
                  currentQuestionType === 6 ? 'Responde SI o NO' :
                  currentQuestionType === 3 ? 'Ingresa tu cédula (6-12 dígitos)' :
                  currentQuestionType === 4 ? 'Ingresa tu teléfono (10 dígitos)' :
                  'Escribe tu mensaje aquí'
                "
                :rules="getValidationRules()"
                class="custom-text-field"
              ></v-text-field>
              
              <!-- Contador de imágenes seleccionadas -->
              <div v-if="selectedFiles.length > 0 || uploadedImageUrls.length > 0" class="images-counter-bar">
                <div class="images-counter">
                  <v-chip v-if="selectedFiles.length > 0" color="primary" small class="mr-2">
                    <v-icon left small>mdi-image-plus</v-icon>
                    {{ selectedFiles.length }} {{ selectedFiles.length === 1 ? 'por cargar' : 'por cargar' }}
                  </v-chip>
                  <v-chip v-if="uploadedImageUrls.length > 0" color="success" small>
                    <v-icon left small>mdi-check</v-icon>
                    {{ uploadedImageUrls.length }} {{ uploadedImageUrls.length === 1 ? 'cargada' : 'cargadas' }}
                  </v-chip>
                </div>
                <div class="action-buttons">
                  <v-btn 
                    v-if="selectedFiles.length > 0" 
                    color="#294697" 
                    small
                    text
                    @click="uploadSelectedImages"
                    :loading="uploadingImage"
                    :disabled="uploadingImage"
                    class="mr-2"
                  >
                    <v-icon left small>mdi-cloud-upload</v-icon>
                    Cargar
                  </v-btn>
                  <v-btn
                    v-if="selectedFilePreviews.length > 0"
                    small
                    text
                    color="grey darken-1"
                    @click="selectedFilePreviews = []; selectedFiles = []"
                  >
                    <v-icon left small>mdi-cancel</v-icon>
                    Limpiar
                  </v-btn>
                </div>
              </div>
              
              <!-- Previsualización compacta de imágenes seleccionadas -->
              <div v-if="selectedFilePreviews.length > 0" class="selected-images-compact">
                <div v-for="(preview, index) in selectedFilePreviews" :key="index" class="preview-container-compact">
                  <template v-if="selectedFiles[index] && selectedFiles[index].type && selectedFiles[index].type.startsWith('image/')">
                    <img :src="preview" class="preview-image-compact" />
                  </template>
                  <template v-else>
                    <v-icon color="primary" class="file-icon-compact" left>mdi-file</v-icon>
                    <span class="file-name-compact">{{ selectedFiles[index] ? selectedFiles[index].name : 'Archivo' }}</span>
                  </template>
                  <v-btn x-small icon color="error" class="remove-image-btn-compact" @click="removeSelectedImage(index)">
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-flex>
            <!-- Botones para mobile: SOLO en xs, uno al lado del otro -->
            <v-flex xs12 class="d-flex d-sm-none justify-end align-center" style="gap:12px;">
              <input
                type="file"
                ref="fileInputMobile"
                multiple
                style="display: none"
                @change="handleFileChange"
              />
              <v-btn
                fab
                small
                color="#294697"
                outlined
                :disabled="!openBot || loadingMessageBot || uploadingImage || waitingForNextQuestion"
                @click="$refs.fileInputMobile.click()"
                class="btn-upload"
                :class="{ 'btn-upload-animated': showImageUploadButton }"
              >
                <v-icon dark>{{ uploadingImage ? 'mdi-loading' : 'mdi-file' }}</v-icon>
              </v-btn>
              <v-btn
                fab
                small
                color="#294697"
                outlined
                :disabled="!openBot || loadingMessageBot || waitingForNextQuestion || (( !message || message.trim() === '' ) && uploadedImageUrls.length === 0)"
                @click="sendMessageOneStep"
                class="btn-send"
              >
                <v-icon dark>mdi-send</v-icon>
              </v-btn>
            </v-flex>
            <!-- Botones para desktop/tablet -->
            <v-flex xs12 sm1 md1 class="d-none d-sm-flex">
              <input
                type="file"
                ref="fileInput"
                multiple
                style="display: none"
                @change="handleFileChange"
              />
              <v-btn
                fab
                color="#294697"
                outlined
                :disabled="!openBot || loadingMessageBot || uploadingImage || waitingForNextQuestion"
                @click="$refs.fileInput.click()"
                class="btn-upload"
                :class="{ 'btn-upload-animated': showImageUploadButton }"
              >
                <v-icon dark>{{ uploadingImage ? 'mdi-loading' : 'mdi-file' }}</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm1 md1 class="d-none d-sm-flex">
              <v-btn
                fab
                color="#294697"
                outlined
                :disabled="!openBot || loadingMessageBot || waitingForNextQuestion || (( !message || message.trim() === '' ) && uploadedImageUrls.length === 0)"
                @click="sendMessageOneStep"
                class="btn-send"
              >
                <v-icon dark>mdi-send</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-else wrap style="margin-top: 30px">
            <v-flex xs12 sm10 md10>
              <p></p>
            </v-flex>
          </v-layout>
          <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="3000"
            bottom
            right
          >
            {{ snackbarText }}
          </v-snackbar>
          
          <!-- Visualizador de imagen a pantalla completa -->
          <div v-if="showFullscreenImage" class="fullscreen-image-container" @click="closeFullscreenImage">
            <div class="fullscreen-image-content" @click.stop>
              <img :src="fullscreenImage" class="fullscreen-image" />
              <v-btn icon dark class="close-fullscreen-btn" @click="closeFullscreenImage">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "../../env";

import io from "socket.io-client";
import store from "../../../store/casosStore";

var salas = 0;
export default {
  data() {
    return {
      loadingMessageBot: false,
      puntoSelect: "",
      bottones: 1,
      user: localStorage.getItem("nombre"),
      puntos: [],
      message: "",
      messages: [],
      allMsg: [],
      cant: 0,
      // socket: io("172.20.0.69:3001", { forceNew: true }),
      socket: io("https://sk-nova.apostar.com.co", { forceNew: true }),
      // socket: io("10.99.16.124:3001", { forceNew: true }),
      openBot: true,
      ipValidated: 1,
      uploadingImage: false,
      showImageUploadButton: false,
      uploadedImageUrl: null,
      uploadedImageUrls: [],
      selectedFiles: [],
      selectedFilePreviews: [], 
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      loading: false,
      isMobile: false,
      fullscreenImage: null,
      showFullscreenImage: false,
      // 🆕 Variables para validación frontend
      currentQuestionType: null,
      pendingMessage: null,
      waitingForValidation: false,
      waitingForNextQuestion: false,
      // 🆕 Variables para timer de inactividad
      inactivityTimer: null,
      lastActivityTime: null,
      inactivityTimeout: 10 * 60 * 1000, // 10 minutos en milisegundos
      warningTimer: null,
      showInactivityWarning: false,
      // 🆕 Variable para bloquear botones después de presionar
      buttonPressed: false,
      // 🆕 Variable para delay de 3 segundos en botón OK
      botonOkDisabled: true,
      // 🆕 Variable para mostrar indicador de carga entre preguntas
      mostrarCargandoPregunta: false
    };
  },
  methods: {
    // Enfocar el campo de mensaje cuando esté disponible
    focusMessageInput() {
      this.$nextTick(() => {
        const inputComponent = this.$refs.messageInput;
        if (inputComponent && typeof inputComponent.focus === 'function') {
          inputComponent.focus();
          return;
        }
        // Fallback al input nativo por si acaso
        const nativeInput = this.$el && this.$el.querySelector('input');
        if (nativeInput && typeof nativeInput.focus === 'function') {
          nativeInput.focus();
        }
      });
    },
    // 🆕 Función para validar respuesta según el tipo de pregunta
    validateResponse(response, questionType) {
      const resp = response.trim();
      
      switch (parseInt(questionType)) {
        case 3: // cedula
          return /^\d{6,12}$/.test(resp);
        case 4: // telefono
          return /^\d{10}$/.test(resp);
        case 2: // numero
          return !isNaN(resp) && resp !== '';
        case 6: // si_no - VALIDACIÓN ESTRICTA
          const respLower = resp.toLowerCase();
          const validSiNo = ['si', 'no', 'sí', 'yes', 'y', 'n'];
          return validSiNo.includes(respLower);
        case 1: // texto
          return resp.length > 0;
        case 5: // archivo
          return resp.length > 0;
        default:
          return resp.length > 0;
      }
    },

    // 🆕 Función para detectar el tipo de pregunta desde el mensaje del bot
    detectQuestionType(botMessage) {
      const message = botMessage.toLowerCase();
      
      // Detectar si/no - PRIORIDAD MÁXIMA
      if (message.includes('sí/no') || message.includes('si/no') || message.includes('(sí/no)') || 
          message.includes('(si/no)') || message.includes('si o no') || message.includes('sí o no')) {
        return 6;
      }
      
      // Detectar cédula
      if (message.includes('cédula') || message.includes('cedula')) {
        return 3;
      }
      
      // Detectar teléfono
      if (message.includes('teléfono') || message.includes('telefono') || message.includes('celular')) {
        return 4;
      }
      
      // Por defecto, texto libre
      return 1;
    },

// 🆕 Función para validar y enviar mensaje
validateAndSendMessage(messageData) {
    // 🆕 CASO ESPECIAL: Para el mensaje "OK" inicial, mostrar inmediatamente
    const hasBotMessages = this.messages.some(msg => msg.user === 'NOVA');
    
    if (messageData.message.toLowerCase() === 'ok' && !hasBotMessages) {
        this.showUserMessage(messageData);
        this.sendMessageToServer(messageData);
        return;
    }

    // Si no hay tipo de pregunta actual, enviar directamente
    if (!this.currentQuestionType) {
        this.showUserMessage(messageData);
        this.sendMessageToServer(messageData);
        return;
    }

    // Validar la respuesta
    const isValid = this.validateResponse(messageData.message, this.currentQuestionType);
    
    if (isValid) {
        // Respuesta válida: mostrar y enviar
        this.showUserMessage(messageData);
        this.sendMessageToServer(messageData);
        this.currentQuestionType = null;
        // Bloquear input hasta que llegue la siguiente pregunta
        this.waitingForNextQuestion = true;
        // 🆕 Resetear timer de inactividad al enviar mensaje
        this.resetInactivityTimer();
    } else {
        // Respuesta inválida: mostrar mensaje de error
        let errorMessage = "Respuesta inválida. Por favor, verifique el formato.";
        
        if (this.currentQuestionType === 6) {
            errorMessage = "❌ Para preguntas de SI/NO, solo puedes responder: SI, NO, SÍ, YES, Y, N";
        } else if (this.currentQuestionType === 3) {
            errorMessage = "❌ Para cédula, ingresa solo números (6-12 dígitos)";
        } else if (this.currentQuestionType === 4) {
            errorMessage = "❌ Para teléfono, ingresa exactamente 10 dígitos";
        }
        
        this.showSnackbar(errorMessage, "error");
        return false;
    }
},

// 🆕 Función para mostrar mensaje del usuario en el chat
showUserMessage(messageData) {
    this.messages.push({
        user: messageData.user,
        message: messageData.message,
        imageUrl: messageData.imageUrl,
        imageUrls: messageData.imageUrls,
        tipo: 1
    });
    // 🆕 Hacer scroll cuando se agrega mensaje del usuario
    this.$nextTick(() => {
        this.scrollToBottom();
    });
},

// 🆕 Función para enviar mensaje al servidor (SIN guardar en BD desde frontend)
sendMessageToServer(messageData) {
    // 🚫 NO guardar en BD desde aquí - el backend lo hará
    // Solo enviar al servidor via socket
    this.socket.emit("SEND_MESSAGE", messageData);
},

    sendInfo() {
      this.loading = true; // Activar estado de carga
      const form = new FormData();
      const idcaso = store.getters.getSala; //Constante donde se guarda el id de caso (cc_id_caso)
      form.append("idPunto", this.puntoSelect);
      form.append("idcaso", idcaso); // Para WhatsApp (opcional)
      form.append("cc_id_caso", idcaso); // ID real del caso en cc_casos (obligatorio)
      const formDataObject = {};
        for (const [key, value] of form.entries()) {
          formDataObject[key] = value;
        }
      axios
      .post(`${env.endpoint}callcenter/create_config2`, form)
      .then(({ data }) => {
          if (data.estado) {
            // Mantener el estado de carga durante un tiempo mínimo
            setTimeout(() => {
              // El loading sigue activo mientras ejecuta ejecucion()
              this.ejecucion();
              // No desactivamos el loading, se mantiene permanentemente
              // El botón quedará desactivado hasta cambiar de pantalla
            }, 1500); // Mantener cargando al menos 1.5 segundos
          } else {
            // En caso de error, permitimos intentar nuevamente
            setTimeout(() => {
              this.loading = false;
              this.showSnackbar("Error al procesar la información. Intente nuevamente.", "error");
            }, 1500);
          }
        })
        .catch(error => {
          // En caso de error de conexión, permitimos intentar nuevamente
          setTimeout(() => {
            this.loading = false;
            this.showSnackbar("Error al enviar la información. Intente nuevamente.", "error");
          }, 1500);
        });
    },
    // >Valida si la IP del equipo está registrada
    // CAMBIO: Ahora SIEMPRE se muestra el selector de punto - todos deben seleccionar manualmente
    hasIP() {
      // ipValidated => 1 - Cargando
      // ipValidated => 2 - Si tiene (YA NO SE USA - siempre mostrar selector)
      // ipValidated => 3 - No tiene (SIEMPRE mostrar selector)
      
      /* CÓDIGO ANTERIOR COMENTADO - Por si se necesita después
      axios
        .get(`${env.endpoint}callcenter/validarPunto`)
        .then(async ({ data }) => {
          if (data.estado) {
            this.ejecucion();
          } else {
            // Obtener idUsuario del localStorage para filtrar puntos por empresa
            const idUsuario = localStorage.getItem("id");
            this.puntos = await axios
              .get(`${env.endpoint}user/puntostodos${idUsuario ? `?idUsuario=${idUsuario}` : ''}`)
              .then(({ data }) => data);
            this.ipValidated = 3;
          }
        });
      */
      
      // NUEVO: SIEMPRE mostrar el selector de punto
      // Todos los usuarios DEBEN seleccionar el punto manualmente
      this.ipValidated = 1; // Cargando
      const idUsuario = localStorage.getItem("id");
      axios
        .get(`${env.endpoint}user/puntostodos${idUsuario ? `?idUsuario=${idUsuario}` : ''}`)
        .then(({ data }) => {
          this.puntos = data;
          this.ipValidated = 3; // Mostrar selector siempre
        })
        .catch((error) => {
          console.error('Error al obtener puntos:', error);
          this.ipValidated = 3; // Mostrar selector incluso si hay error
        });
    },
    // boton de respuesta OK
    boton() {
      // 🆕 Bloquear botón si ya se presionó
      if (this.buttonPressed) return;
      
      if (!store.getters.getRequerimiento || !store.getters.getSala)
        return (location.href = "/callcenter/asesor");

      // 🆕 Marcar botón como presionado
      this.buttonPressed = true;

        const messageData = {
  user: localStorage.getItem("nombre"),
  id_usuario: localStorage.getItem("idUsuario"),
  requerimiento: store.getters.getRequerimiento,
  message: "ok",
  rol: localStorage.getItem("rolCall"),
  sala: store.getters.getSala,
};

      // 🆕 Usar validación frontend
      this.validateAndSendMessage(messageData);
      this.message = "";
      this.bottones = 2;
      // 🆕 Mostrar indicador de carga
      this.mostrarCargandoPregunta = true;
      // 🆕 Resetear timer de inactividad
      this.resetInactivityTimer();
    },
    // boton de respuesta NO
    boton1() {
      // 🆕 Bloquear botón si ya se presionó
      if (this.buttonPressed) return;
      
      // 🆕 Marcar botón como presionado
      this.buttonPressed = true;
      
      const messageData = {
        user: localStorage.getItem("nombre"),
        id_usuario: localStorage.getItem("idUsuario"),
        requerimiento: store.getters.getRequerimiento,
        message: "no",
        rol: localStorage.getItem("rolCall"),
        sala: store.getters.getSala,
      };

      // 🆕 Usar validación frontend
      this.validateAndSendMessage(messageData);
      this.message = "";
      // 🆕 Mostrar indicador de carga
      this.mostrarCargandoPregunta = true;
      // 🆕 Resetear timer de inactividad
      this.resetInactivityTimer();
    },
    // boton de respuesta SI
    boton2() {
      // 🆕 Bloquear botón si ya se presionó
      if (this.buttonPressed) return;
      
      // 🆕 Marcar botón como presionado
      this.buttonPressed = true;
      
      const messageData = {
        user: localStorage.getItem("nombre"),
        id_usuario: localStorage.getItem("idUsuario"),
        requerimiento: store.getters.getRequerimiento,
        message: "si",
        rol: localStorage.getItem("rolCall"),
        sala: store.getters.getSala,
      };

      // 🆕 Usar validación frontend
      this.validateAndSendMessage(messageData);
      this.message = "";
      // 🆕 Mostrar indicador de carga
      this.mostrarCargandoPregunta = true;
      // 🆕 Resetear timer de inactividad
      this.resetInactivityTimer();
    },
    //respuesta abierta
    sendMessage(e) {
      e.preventDefault();
      
      // Si hay archivos seleccionados, súbelos primero
      if (this.selectedFiles.length > 0 && !this.uploadedImageUrl) {
        this.uploadImage(this.selectedFiles[0]);
        return;
      }
      
      // Nueva validación: no permitir solo espacios
      if (((!this.message || this.message.trim() === "") && !this.uploadedImageUrl)) return; // No enviar vacío ni solo espacios

      // 🆕 VALIDACIÓN ESPECIAL PARA SI/NO: Normalizar respuesta
      let messageToSend = this.message.trim();
      if (this.currentQuestionType === 6) {
        const respLower = messageToSend.toLowerCase();
        if (['yes', 'y'].includes(respLower)) {
          messageToSend = 'si';
        } else if (['n'].includes(respLower)) {
          messageToSend = 'no';
        }
      }

      // Crear objeto del mensaje para enviar al servidor y mostrar localmente
      const messageData = {
        user: localStorage.getItem("nombre"),
        id_usuario: localStorage.getItem("idUsuario"),
        requerimiento: store.getters.getRequerimiento,
        message: messageToSend,
        imageUrl: this.uploadedImageUrl, // Para compatibilidad
        imageUrls: this.uploadedImageUrls, // Array de URLs
        rol: localStorage.getItem("rolCall"),
        sala: store.getters.getSala,
      };

      // 🆕 Usar validación frontend antes de enviar
      const validationResult = this.validateAndSendMessage(messageData);
      
      // Si la validación falló, no continuar
      if (validationResult === false) {
        return;
      }

      this.message = "";
      // 🆕 Mostrar indicador de carga
      this.mostrarCargandoPregunta = true;
      // 🆕 Resetear timer de inactividad al enviar mensaje
      this.resetInactivityTimer();
      
      // Mantener las URLs de imágenes para poder seguir agregando más
      // Esto es crucial para la acumulación de imágenes
      // Sólo limpiamos cuando el usuario decide enviar el mensaje
      if (e.type !== 'custom') {
        // Si es un evento real de envío (no automático después de subir), limpiamos todo
        this.uploadedImageUrl = null;
        this.uploadedImageUrls = [];
        this.selectedFiles = [];
        this.selectedFilePreviews = [];
      }
    },
    // Manejar el cambio de archivo
    handleFileChange(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      
      // Agregar los nuevos archivos a los existentes en lugar de reemplazarlos
      const newFiles = Array.from(files);
      this.selectedFiles = [...this.selectedFiles, ...newFiles];
      
      // Crear previsualizaciones solo para los nuevos archivos
      for (const file of newFiles) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.selectedFilePreviews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
      
      // Limpiar el input de archivo para permitir seleccionar el mismo archivo nuevamente
      this.$refs.fileInput.value = null;
    },
    // Eliminar una imagen seleccionada
    removeSelectedImage(index) {
      this.selectedFilePreviews.splice(index, 1);
      this.selectedFiles.splice(index, 1);
    },
    // Subir imagen al servidor
    async uploadImage(file) {
      if ((!file && this.selectedFiles.length === 0) || this.uploadingImage) return;
      
      const idcaso = store.getters.getSala;
      if (!idcaso) {
        this.showSnackbar("Error: No se pudo obtener el ID del caso", "error");
        return;
      }
      
      this.uploadingImage = true;
      
      // Crear FormData para enviar al servidor
      const formData = new FormData();
      
      // Agregar todos los archivos seleccionados
      if (this.selectedFiles.length > 0) {
        for (const file of this.selectedFiles) {
          formData.append("evidencias[]", file);
        }
        formData.append("cc_id_caso", idcaso);


        // enpoint para subir imagenes al chat 
        try {
          const response = await axios.post(`${env.endpointEvidencias}`,  

          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          
          if (response.data && response.data.status === "success") {
            // Guardar las rutas de todas las imágenes
            if (response.data.detalles && Array.isArray(response.data.detalles)) {
              // Conservar URLs anteriores y agregar las nuevas
              const newImageUrls = response.data.detalles.map(item => item.path);
              this.uploadedImageUrls = [...this.uploadedImageUrls, ...newImageUrls];
              // Para compatibilidad con código existente
              this.uploadedImageUrl = JSON.stringify(this.uploadedImageUrls);
            } else {
              // Si solo hay una imagen, agregarla al array existente
              this.uploadedImageUrls = [...this.uploadedImageUrls, response.data.path];
              this.uploadedImageUrl = JSON.stringify(this.uploadedImageUrls);
            }
            
            this.showSnackbar("Imágenes subidas correctamente", "success");
            
            // No enviamos automáticamente el mensaje para permitir al usuario agregar más imágenes
            // Solo limpiamos los archivos seleccionados para que pueda seleccionar otros
            this.selectedFiles = [];
            this.selectedFilePreviews = [];
          } else {
            this.showSnackbar("Error al subir las imágenes", "error");
          }
        } catch (error) {
          this.showSnackbar("Error al subir las imágenes", "error");
        } finally {
          this.uploadingImage = false;
          // Limpiar solo el input de archivo, mantener las previsualizaciones
          this.$refs.fileInput.value = null;
        }
      }
    },
    // Mostrar snackbar
    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    ejecucion() {
      setTimeout(() => {
        this.socket.emit("CHANGE", {
          sala: store.getters.getSala,
          requerimiento: store.getters.getRequerimiento,
          rol: localStorage.getItem("rolCall"),
        });
        salas = store.getters.getSala;
        this.ipValidated = 2; // Cancela el loader del chat
      }, 1500);

      this.socket.on("MESSAGE", async (data) => {
        // Agregar todos los mensajes que vienen del servidor
        this.messages = [...this.messages, data];
        
        var nuevoMSG = {
          user: data.user,
          message: data.message,
          tipo: data.tipo,
        };

        if (data.open == false) {
          this.openBot = false;
        } else {
          this.openBot = true;
        }

        // 🆕 Detectar tipo de pregunta cuando llega mensaje del bot - MEJORADO
        if (data.user === "NOVA") {
          // 🆕 Ocultar indicador de carga cuando llega mensaje del bot
          this.mostrarCargandoPregunta = false;
          // 🆕 Desbloquear botones cuando llega nueva pregunta del bot
          this.buttonPressed = false;
          
          // 🆕 Hacer scroll automático cuando llega mensaje del bot
          this.$nextTick(() => {
            this.scrollToBottom();
          });
          
          // 🆕 PRIORIDAD 1: Detectar "ok" en el mensaje directamente
          if (data.message && (data.message.includes("ok|OK") || data.message.includes("ok") || data.message.includes("OK") || data.message.includes('"ok"') || data.message.includes("'ok'"))) {
            this.bottones = 1;
            this.currentQuestionType = null;
            this.waitingForNextQuestion = false;
            // 🆕 Deshabilitar botón OK por 3 segundos
            this.botonOkDisabled = true;
            setTimeout(() => {
              this.botonOkDisabled = false;
            }, 3000);
          } else if (data.message && data.message.includes("si|no")) {
            this.bottones = 2;
            this.currentQuestionType = 6;
            this.waitingForNextQuestion = false;
          } else if (data.validacion && (data.validacion.includes("ok") || data.validacion.includes("OK"))) {
            // 🆕 PRIORIDAD 2: Usar campo validacion
            this.bottones = 1;
            this.currentQuestionType = null;
            this.waitingForNextQuestion = false;
            // 🆕 Deshabilitar botón OK por 3 segundos
            this.botonOkDisabled = true;
            setTimeout(() => {
              this.botonOkDisabled = false;
            }, 3000);
          } else if (data.validacion && data.validacion.includes("si|no")) {
            this.bottones = 2;
            this.currentQuestionType = 6;
            this.waitingForNextQuestion = false;
          } else if (data.tipo === 1) {
            // Solo detectar automáticamente si es tipo 1 (respuesta abierta)
            this.currentQuestionType = this.detectQuestionType(data.message);
            // Desbloquear input cuando llega nueva pregunta
            this.waitingForNextQuestion = false;
            
            // 🆕 Si es pregunta SI/NO, mostrar botones en lugar de campo de texto
            if (this.currentQuestionType === 6) {
              this.bottones = 2; // Cambiar a botones SI/NO
            }
          } else if (data.tipo === 0 || data.tipo === 3) {
            // Para tipo 0 y 3, desbloquear para que se pueda hacer click en OK
            this.waitingForNextQuestion = false;
          }
        }

        // 🆕 Detectar cuando el chat termina y redirigir a /user
        if (data.user === "NOVA" && data.message && 
            (data.message.includes("El bot ha escalado el caso, no podra enviar mas mensajes") ||
              data.message.includes("El bot ha cerrado el caso, no podra enviar mas mensajes") ||
              data.message.includes("Caso solucionado"))) {
          
          // 🔧 DIFERENCIAR ENTRE CASO SOLUCIONADO Y ESCALADO
          if (data.message.includes("Caso solucionado")) {
            this.showSnackbar("¡Caso solucionado exitosamente! Serás redirigido a la página principal en 5 segundos...", "success");
          } else {
            this.showSnackbar("Chat finalizado. Serás redirigido a la página principal en 5 segundos...", "info");
          }
          
          // Esperar un momento para que el usuario vea el mensaje final
          setTimeout(() => {
            location.href = "/user";
          }, 3000); // 3 segundos de delay
        }

        // Verificar si el mensaje contiene palabras clave para activar la animación del botón
        if (
          data.user === "NOVA" && 
          (
            data.message.toLowerCase().includes("envie una foto") || 
            data.message.toLowerCase().includes("sube una foto") ||
            data.message.toLowerCase().includes("sube una imagen") ||
            data.message.toLowerCase().includes("envie una imagen") ||
            data.message.toLowerCase().includes("evidencia") ||
            data.message.toLowerCase().includes("foto") ||
            data.message.toLowerCase().includes("imagen") ||
            data.message.toLowerCase().includes("subir foto") ||
            data.message.toLowerCase().includes("subir imagen") ||
            data.message.toLowerCase().includes("subir evidencia") ||
            data.message.toLowerCase().includes("subir foto") ||
            data.message.toLowerCase().includes("subir imagen") ||
            data.message.toLowerCase().includes("subir evidencia") ||
            data.message.toLowerCase().includes("falla")
  
          )
        ) {
          this.showImageUploadButton = true;
        }

        // 🔧 SOLO GUARDAR MENSAJES DEL BOT - Los mensajes del usuario se manejan desde frontend
        if (data.user === "NOVA") {
          var mensajeJson = JSON.stringify(nuevoMSG);
          var bodyFormData = new FormData();

          bodyFormData.append("mensajes", mensajeJson);
          bodyFormData.append("sala", store.getters.getSala);

          this.loadingMessageBot = true;
          setTimeout(() => {
            axios
              .post(
                `${env.endpoint}callcenter/update_conversacion`,
                bodyFormData
              )
              .then((resp) => (this.loadingMessageBot = false));
          }, data.user === "NOVA" ? 1000 : 500);
        }

        this.cant = this.messages.length - 1;
        //validacion de pregunta para asignacion de tipo de respuesta
        // 🆕 PRIORIDAD MÁXIMA: Detectar "ok" en el mensaje
        if (data.message && (data.message.includes("ok|OK") || data.message.includes("ok") || data.message.includes("OK") || data.message.includes('"ok"') || data.message.includes("'ok'"))) {
          this.bottones = 1;
          this.currentQuestionType = null;
          // 🆕 Deshabilitar botón OK por 3 segundos
          this.botonOkDisabled = true;
          setTimeout(() => {
            this.botonOkDisabled = false;
          }, 3000);
        } else if (data.validacion && (data.validacion.includes("ok") || data.validacion.includes("OK"))) {
          // Mostrar solo botón OK
          this.bottones = 1;
          this.currentQuestionType = null;
          // 🆕 Deshabilitar botón OK por 3 segundos
          this.botonOkDisabled = true;
          setTimeout(() => {
            this.botonOkDisabled = false;
          }, 3000);
        } else if (data.validacion && data.validacion.includes("si|no")) {
          // Mostrar botones SI/NO
          this.bottones = 2;
          this.currentQuestionType = 6;
        } else if (nuevoMSG.tipo === 0) {
          // 🆕 Solo botón OK - mensaje informativo
          this.bottones = 1;
          this.currentQuestionType = null;
          // 🆕 Deshabilitar botón OK por 3 segundos
          this.botonOkDisabled = true;
          setTimeout(() => {
            this.botonOkDisabled = false;
          }, 3000);
        } else if (nuevoMSG.tipo === 1) {
          //respuesta abierta
          // Si ya detectamos que es SI/NO, mantener bottones = 2
          if (this.currentQuestionType !== 6) {
            this.bottones = 3;
          }
        } else if (nuevoMSG.tipo === 2) {
          //termino de chat
          this.bottones = 4;
        } else if (nuevoMSG.tipo === 3) {
          // respuesta ok
          this.bottones = 1;
          // 🆕 Deshabilitar botón OK por 3 segundos
          this.botonOkDisabled = true;
          setTimeout(() => {
            this.botonOkDisabled = false;
          }, 3000);
        } else if (nuevoMSG.tipo === 6) {
          // 🆕 Pregunta SI/NO con botones
          this.bottones = 2;
          this.currentQuestionType = 6;
        }
      });
    },
    // Verificar si un string es JSON válido
    isJsonString(str) {
      if (typeof str !== 'string') return false;
      try {
        const json = JSON.parse(str);
        return typeof json === 'object' && json !== null && Array.isArray(json);
      } catch (e) {
        return false;
      }
    },
    // Abrir imagen en pantalla completa
    openImageFullscreen(url) {
      this.fullscreenImage = url;
      this.showFullscreenImage = true;
    },
    // Cerrar imagen en pantalla completa
    closeFullscreenImage() {
      this.showFullscreenImage = false;
      this.fullscreenImage = null;
    },
    // Subir las imágenes seleccionadas
    uploadSelectedImages() {
      if (this.selectedFiles.length > 0) {
        this.uploadImage();
      }
    },
    // Método simplificado para enviar imágenes en un solo paso
    sendMessageOneStep(e) {
      e.preventDefault();
      
      // Si hay archivos seleccionados sin cargar, primero los cargamos
      if (this.selectedFiles.length > 0 && !this.uploadingImage) {
        this.uploadSelectedImages();
        return;
      }
      
      // Si ya tenemos archivos cargados o un mensaje, lo enviamos
      this.sendMessage(e);
    },
    // Extraer y mostrar el nombre del archivo desde la URL
    getFileName(url) {
      if (!url) return '';
      try {
        return decodeURIComponent(url.split('/').pop().split('?')[0]);
      } catch (e) {
        return url;
      }
    },
    
    // 🆕 Función para obtener reglas de validación según el tipo de pregunta
    getValidationRules() {
      if (this.currentQuestionType === 6) {
        return [
          v => !!v || 'Campo requerido',
          v => ['si', 'no', 'sí', 'yes', 'y', 'n'].includes(v.toLowerCase()) || 'Solo se permite: SI, NO, SÍ, YES, Y, N'
        ];
      } else if (this.currentQuestionType === 3) {
        return [
          v => !!v || 'Campo requerido',
          v => /^\d{6,12}$/.test(v) || 'Cédula debe tener entre 6 y 12 dígitos'
        ];
      } else if (this.currentQuestionType === 4) {
        return [
          v => !!v || 'Campo requerido',
          v => /^\d{10}$/.test(v) || 'Teléfono debe tener exactamente 10 dígitos'
        ];
      }
      return [v => !!v || 'Campo requerido'];
    },

    // 🆕 Métodos para manejar inactividad
    resetInactivityTimer() {
      this.lastActivityTime = Date.now();
      this.showInactivityWarning = false;
      
      // Limpiar timers existentes
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
      }
      
      // Mostrar advertencia a los 8 minutos (2 minutos antes del cierre)
      this.warningTimer = setTimeout(() => {
        this.showInactivityWarning = true;
        this.showSnackbar("⚠️ El chat se cerrará en 2 minutos por inactividad. Escribe algo para mantenerlo activo.", "warning");
      }, 8 * 60 * 1000); // 8 minutos
      
      // Cerrar chat a los 10 minutos
      this.inactivityTimer = setTimeout(() => {
        this.closeChatDueToInactivity();
      }, this.inactivityTimeout);
    },

    closeChatDueToInactivity() {
      this.showSnackbar("⏰ Chat cerrado por inactividad. Serás redirigido a la página principal...", "warning");
      
      // Limpiar todos los timers
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
      }
      
      // Esperar un momento para que el usuario vea el mensaje
      setTimeout(() => {
        this.$router.push('/user');
      }, 3000); // 3 segundos de delay
    },

    // Detectar actividad del usuario
    detectUserActivity() {
      this.resetInactivityTimer();
    },
    // 🆕 Método para hacer scroll al final del chat
    scrollToBottom() {
      this.$nextTick(() => {
        // Buscar el contenedor de scroll del chat
        const chatContainer = document.getElementById('divu');
        if (chatContainer) {
          const scrollContainer = chatContainer.querySelector('[style*="overflow-y"]');
          if (scrollContainer) {
            // Hacer scroll suave al final
            scrollContainer.scrollTo({
              top: scrollContainer.scrollHeight,
              behavior: 'smooth'
            });
          } else {
            // Fallback: buscar cualquier elemento con scroll
            const scrollableElements = chatContainer.querySelectorAll('[style*="overflow"]');
            if (scrollableElements.length > 0) {
              scrollableElements[0].scrollTo({
                top: scrollableElements[0].scrollHeight,
                behavior: 'smooth'
              });
            }
          }
        }
      });
    },
  },
  watch: {
    // Cuando cambie el tipo de botones y el input quede disponible
    bottones(newVal) {
      if (newVal === 3 && !this.loadingMessageBot && !this.waitingForNextQuestion) {
        this.focusMessageInput();
      }
      // 🆕 Hacer scroll cuando cambie el tipo de botones (especialmente para SI/NO)
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // Cuando deje de cargar el mensaje del bot
    loadingMessageBot(newVal) {
      if (!newVal && this.bottones === 3 && !this.waitingForNextQuestion) {
        this.focusMessageInput();
      }
    },
    // Cuando el bot envíe la siguiente pregunta
    waitingForNextQuestion(newVal) {
      if (!newVal && this.bottones === 3 && !this.loadingMessageBot) {
        this.focusMessageInput();
      }
    },
    // 🆕 Watch para hacer scroll cuando aparece el indicador de carga
    mostrarCargandoPregunta(newVal) {
      if (newVal) {
        // Usar setTimeout adicional para asegurar que el DOM se actualice
        setTimeout(() => {
          this.$nextTick(() => {
            const chatContainer = document.getElementById('divu');
            if (chatContainer) {
              const scrollContainer = chatContainer.querySelector('[style*="overflow-y"]');
              if (scrollContainer) {
                scrollContainer.scrollTop = scrollContainer.scrollHeight;
              }
            }
          });
        }, 100);
      }
    }
  },
  mounted() {
    this.hasIP();
    // Detectar si es dispositivo móvil
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Aplicar estilos específicos para móvil si es necesario
    const uploadBtn = document.querySelector('.btn-upload');
    if (uploadBtn) {
      uploadBtn.style.marginBottom = '15px';
    }
    
    // 🆕 Inicializar variables de timer
    this.lastActivityTime = Date.now();
    this.showInactivityWarning = false;
    // 🆕 Iniciar timer de inactividad
    this.resetInactivityTimer();
    // Intentar enfocar si ya está disponible
    if (this.bottones === 3 && !this.loadingMessageBot && !this.waitingForNextQuestion) {
      this.focusMessageInput();
    }
    
    // 🆕 Agregar event listeners para detectar actividad
    document.addEventListener('click', this.detectUserActivity);
    document.addEventListener('keypress', this.detectUserActivity);
    document.addEventListener('keydown', this.detectUserActivity);
    document.addEventListener('mousemove', this.detectUserActivity);
    document.addEventListener('scroll', this.detectUserActivity);
    
    // 🆕 Agregar listener para el input del chat
    this.$nextTick(() => {
      const messageInput = this.$refs.messageInput;
      if (messageInput && messageInput.$el) {
        // Si es un componente Vuetify, acceder al elemento DOM
        const inputElement = messageInput.$el.querySelector('input');
        if (inputElement) {
          inputElement.addEventListener('input', this.detectUserActivity);
        }
      }
    });
    
  },
  beforeDestroy() {
    // 🆕 Limpiar timers y event listeners al destruir el componente
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
    if (this.warningTimer) {
      clearTimeout(this.warningTimer);
    }
    
    // Remover event listeners
    document.removeEventListener('click', this.detectUserActivity);
    document.removeEventListener('keypress', this.detectUserActivity);
    document.removeEventListener('keydown', this.detectUserActivity);
    document.removeEventListener('mousemove', this.detectUserActivity);
    document.removeEventListener('scroll', this.detectUserActivity);
    
    // Remover listener del input del chat
    const messageInput = this.$refs.messageInput;
    if (messageInput && messageInput.$el) {
      // Si es un componente Vuetify, acceder al elemento DOM
      const inputElement = messageInput.$el.querySelector('input');
      if (inputElement) {
        inputElement.removeEventListener('input', this.detectUserActivity);
      }
    }
  },
};
</script>

<style>
.btn-send {
  margin: 0 0 0 30px;
}
.btn-upload {
  margin: 0 0 0 15px;
}
.btn-upload-animated {
  animation: pulse 1.5s infinite;
}
.uploaded-image {
  max-width: 100%;
  max-height: 150px;
  border-radius: 5px;
  margin-top: 5px;
  cursor: pointer;
  transition: transform 0.2s;
}
.uploaded-image:hover {
  transform: scale(1.05);
}
.chat-image-container {
  margin: 5px;
  display: inline-block;
}
.image-preview {
  text-align: center;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}
.selected-images-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
}
.preview-container {
  position: relative;
  width: 100px;
  height: 100px;
}
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #ddd;
}
.remove-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 1;
}
.fullscreen-image-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 202;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fullscreen-image-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}
.fullscreen-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}
.close-fullscreen-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.btn {
  margin-left: 40px;
}
.btn1 {
  border-radius: 12px;
  font-size: 2em;
  padding: 0.85em 0.75em;
  margin: 1rem;
  position: relative;
}
.msg-user {
  font-size: 16px;
}
.msg-msg {
  font-size: 14px;
}

.ip-validator {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: system-ui;
}
.ip-validator h1 {
  color: #000;
}
.ip-validator button {
  background: #0077ff;
  border-radius: 6px;
  color: white;
  padding: 5px 10px;
  width: fit-content;
}
.loader {
  display: grid;
  width: 100%;
  /* height: 20px; */
  place-content: center;
}
.loader span {
  animation: spin linear 2s infinite;
  border-radius: 50px;
  border-left: 3px solid #064f8e;
  border-right: 3px solid #064f8e;
  border-top: 3px solid transparent;
  border-bottom: 3px solid #064f8e;
  width: 20px;
  height: 20px;
}


@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 6px 2px rgba(25, 94, 173, 0.6);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(227, 179, 47, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(227, 179, 47, 0);
  }
}
@media ( max-width: 1000px ) {
  #containerChat{
    height: 100vh !important;
    width:200vw; 
    margin-left: -190px;
  }
  #chatBoot{
    left: 208px !important;
    width: 100vw !important;
  }
  #messageUser{
    width: 80% !important;
    margin: 5px 10px 0px 65px !important;

  }
  #messageBot{
    width: 80% !important;
  }
  .selected-images-preview {
    max-height: 150px;
    overflow-y: auto;
    justify-content: center;
  }
  .image-preview {
    max-height: 200px;
    overflow-y: auto;
  }
  .preview-container {
    width: 80px;
    height: 80px;
  }
  .fullscreen-image {
    max-width: 100%;
    max-height: 80vh;
  }
}
.upload-selected-btn {
  margin: 10px auto;
  display: block;
}
.uploaded-images-preview {
  margin: 10px;
  padding: 10px;
  background-color: rgba(173, 25, 51, 0.1);
  border-radius: 5px;
}
.uploaded-images-counter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px;
}
.images-counter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 8px;
}
.images-counter {
  display: flex;
  align-items: center;
}
.action-buttons {
  display: flex;
  align-items: center;
}
.selected-images-compact {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 8px;
  padding: 5px 10px;
  max-height: 80px;
  margin-bottom: 8px;
}
.preview-container-compact {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  margin-bottom: 0;
  padding: 0;
  min-width: unset;
  min-height: unset;
  width: auto;
  height: auto;
}
.preview-container-compact img.preview-image-compact {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
  margin: 0;
}
.preview-container-compact .file-icon-compact {
  font-size: 32px !important;
  margin: 0 8px 0 8px;
}
.preview-container-compact .file-name-compact {
  font-size: 14px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
.remove-image-btn-compact {
  position: absolute !important;
  top: 2px !important;
  right: 2px !important;
  z-index: 2;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-width: 24px !important;
  min-height: 24px !important;
  width: 24px !important;
  height: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-texto-blanco {
  color: white !important;
}

/* Estilos para cambiar el color del borde y mensajes de error a azul */
.custom-text-field .v-messages__message {
  color: #294697 !important;
}

/* Cambiar borde rojo a azul cuando hay errores */
.custom-text-field.v-input--error .v-input__control .v-input__slot {
  border-color: #294697 !important;
}

.custom-text-field.v-input--error .v-input__control .v-input__slot fieldset {
  border-color: #294697 !important;
}

.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline {
  border-color: #294697 !important;
}

.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__start {
  border-color: #294697 !important;
}

.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__end {
  border-color: #294697 !important;
}

.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__notch {
  border-color: #294697 !important;
}

/* Estilos más específicos para Vuetify 2.x */
.custom-text-field .v-input__control .v-input__slot .v-field__outline {
  border-color: #294697 !important;
}

.custom-text-field .v-input__control .v-input__slot .v-field__outline__start {
  border-color: #294697 !important;
}

.custom-text-field .v-input__control .v-input__slot .v-field__outline__end {
  border-color: #294697 !important;
}

.custom-text-field .v-input__control .v-input__slot .v-field__outline__notch {
  border-color: #294697 !important;
}

/* Estilos adicionales para forzar el color azul */
.custom-text-field .v-input__control .v-input__slot fieldset {
  border-color: #294697 !important;
}

.custom-text-field .v-input__control .v-input__slot .v-field__outline,
.custom-text-field .v-input__control .v-input__slot .v-field__outline__start,
.custom-text-field .v-input__control .v-input__slot .v-field__outline__end,
.custom-text-field .v-input__control .v-input__slot .v-field__outline__notch {
  border-color: #294697 !important;
}

/* Override específico para el estado de error */
.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline,
.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__start,
.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__end,
.custom-text-field.v-input--error .v-input__control .v-input__slot .v-field__outline__notch {
  border-color: #294697 !important;
}

/* Estilo global más agresivo para forzar el color azul */
.custom-text-field * {
  border-color: #294697 !important;
}

.custom-text-field .v-input__control .v-input__slot * {
  border-color: #294697  !important;
}

/* 🆕 Animación para puntos suspensivos de "Espere..." */
@keyframes dots-animation {
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
}

.dots-animation {
  display: inline-block;
  width: 20px;
  text-align: left;
  animation: dots-blink 1.5s infinite;
}

@keyframes dots-blink {
  0%, 20% { opacity: 0; }
  40% { opacity: 1; }
  60%, 80% { opacity: 0; }
  100% { opacity: 1; }
}

/* Estilo adicional para el mensaje de carga */
.loading-message {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 600px) {
  html, body {
    height: auto !important;
    min-height: 100vh !important;
    overflow-y: auto !important;
  }
  #containerChat {
    min-height: 100vh !important;
    height: auto !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding-bottom: 120px !important; /* Más espacio para los botones */
  }
  #chatBoot {
    min-height: 100vh !important;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }
  .v-application--wrap {
    min-height: 100vh !important;
    height: auto !important;
    overflow: visible !important;
  }
  .d-flex.d-sm-none {
    display: flex !important;
    flex-direction: row !important;
    gap: 12px !important;
    margin-top: 10px;
  }
  .d-none.d-sm-flex {
    display: none !important;
  }
  .btn-upload, .btn-send {
    margin: 0 !important;
    min-width: 48px !important;
    min-height: 48px !important;
    width: 48px !important;
    height: 48px !important;
  }
}

/* Fuerza el scroll vertical en todo momento en mobile */
@media (max-width: 600px) {
  body, html, #app, .v-application {
    min-height: 100vh !important;
    height: auto !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
}
</style>
